import React from "react";

import { SelectTags } from "src/app/components/SelectTags/SelectTags";
import allRangeOptions from "./utils/followerRangeOptions";
import getLabels from "./utils/getLabels";

const allRangeLabels = getLabels(allRangeOptions);

export default function FollowersRangeTags({
  selectedRangeTags,
  setSelectedRangeTags,
  isExpandable,
  disabled,
}) {
  const handleSetRange = (range) => {
    const predefinedRangeOption = allRangeOptions.find(
      (option) => option.label === range,
    );
    if (predefinedRangeOption) {
      setSelectedRangeTags((prev) => {
        const formattedRangeOption = {
          min: predefinedRangeOption.min,
          max: predefinedRangeOption.max,
        };

        if (
          prev.findIndex((item) => item.min === formattedRangeOption.min) > -1
        ) {
          return prev.filter((item) => item.min !== formattedRangeOption.min);
        }
        return [...prev, formattedRangeOption];
      });
    }
  };

  const selectedRanges = allRangeOptions.filter(
    (option) =>
      selectedRangeTags.findIndex((item) => item.min === option.min) > -1,
  );
  const selectedRangesLabels = getLabels(selectedRanges);

  return (
    <SelectTags
      feed={allRangeLabels}
      values={selectedRangesLabels}
      setValue={handleSetRange}
      unsetValue={handleSetRange}
      clearValues={() => setSelectedRangeTags([])}
      isDataFilterNameFromValue
      isExpandable={isExpandable}
      disabled={disabled}
    />
  );
}
